import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import {rootReducer, rootSaga} from './store-def';



const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignore file objects in import actions
            ignoredActions: [
                'calculations/IMPORT_CALCULATION_REQUEST',
                'calculations/IMPORT_CALCULATION_OLD_REQUEST'
            ],
            ignoredActionPaths: ['payload.file'],
        }
    }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
});


sagaMiddleware.run(rootSaga);

export default store;
